import { useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'

import { authService } from 'services/auth.services'

import Button from 'components/form-inputs/button'
import InputField from 'components/form-inputs/input-field'

const ChangePassword = () => {
  const [loading, setLoading] = useState(false)

  const validationSchema = Yup.object({
    current_password: Yup.string().label('Current password').min(4).required(),
    new_password: Yup.string().label('New password').min(4).required(),
    confirm_password: Yup.string()
      .label('Confirm password')
      .min(4)
      .oneOf([Yup.ref('new_password')], 'Passwords must match')
      .required()
  })

  const formik: any = useFormik({
    initialValues: {
      current_password: '',
      new_password: '',
      confirm_password: ''
    },
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true)
      try {
        await authService.changePassword(values)
        formik.resetForm()
      } finally {
        setLoading(false)
      }
    }
  })
  return (
    <>
      <div
        id="set-password-modal"
        tabIndex={-1}
        aria-hidden="true"
        className="fixed top-0 right-0 left-0 z-50 flex hidden h-[calc(100%-1rem)] max-h-full w-full items-center justify-center overflow-x-hidden overflow-y-auto md:inset-0"
      >
        <div className="relative max-h-full w-full max-w-2xl p-4">
          {/* Modal Content */}
          <div className="relative z-10 max-h-full w-full max-w-2xl p-4">
            <div className="relative rounded-lg border border-gray-200 bg-white shadow-sm">
              <div className="flex items-center justify-between rounded-t border-b border-gray-200 p-3 px-5">
                <h3 className="text-lg font-semibold">Change Password</h3>
                <button
                  type="button"
                  className="ms-auto inline-flex h-8 w-8 items-center justify-center rounded-lg bg-transparent text-sm text-gray-400"
                  data-modal-hide="set-password-modal"
                >
                  <svg
                    className="h-3 w-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 14"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                    />
                  </svg>
                  <span className="sr-only">Close modal</span>
                </button>
              </div>
              <form className="p-5" onSubmit={formik.handleSubmit}>
                <label
                  htmlFor="description"
                  className="mb-2 flex text-sm leading-none font-medium text-gray-700"
                >
                  Current Password
                </label>
                <InputField
                  name="current_password"
                  type="password"
                  placeholder="Current password"
                  onChange={formik.handleChange}
                  value={formik.values.current_password}
                  onBlur={formik.handleBlur}
                  error={formik.touched.current_password && formik.errors.current_password}
                  required
                />

                <div className="mb-5">
                  <label
                    htmlFor="description"
                    className="mb-2 flex text-sm leading-none font-medium text-gray-700"
                  >
                    New Password
                  </label>

                  <InputField
                    name="new_password"
                    type="password"
                    placeholder="New Password"
                    onChange={formik.handleChange}
                    value={formik.values.new_password}
                    onBlur={formik.handleBlur}
                    error={formik.touched.new_password && formik.errors.new_password}
                    required
                  />
                </div>
                <div className="mb-5">
                  <label
                    htmlFor="description"
                    className="mb-2 flex text-sm leading-none font-medium text-gray-700"
                  >
                    Confirm Password
                  </label>
                  <InputField
                    name="confirm_password"
                    type="password"
                    placeholder="Confirm Password"
                    onChange={formik.handleChange}
                    value={formik.values.confirm_password}
                    onBlur={formik.handleBlur}
                    error={formik.touched.confirm_password && formik.errors.confirm_password}
                    required
                  />
                  <div className="mt-3">
                    <Button
                      label="Submit"
                      type="submit"
                      className="rounded-lg bg-purple-900 py-2 text-center text-sm text-white transition hover:bg-purple-950"
                      loading={loading}
                      disabled={!formik.isValid || !formik.dirty}
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default ChangePassword
